import { Button, Card, Col, Modal, Row, Space } from "antd";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { useState } from "react";
const ExpenseWorkflow = ({
    currentExpenseWorkflow = [],
    setIsExpenseModalOpen = () => { },
}) => {
    const { t, i18n } = useTranslation();
    const language = i18n.language === 'en' ? "En" : ""

    const [listEmployees, setListEmployees] = useState({});
    const [openListEmployee, setOpenListEmployee] = useState(false);

    function formatDateTime(dateString) {
        if (!dateString) return;
        const date = dayjs(dateString);
        return date.format(i18n.language === "en" ? "DD/MM/YYYY HH:mm" : `DD/MM/${date.year() + 543} HH:mm`);
    }

    return (
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
            <>
                {
                    Array.isArray(currentExpenseWorkflow) &&
                    currentExpenseWorkflow?.map((workflow, index) => (
                        <>
                            <label>{`${t('leave_type.label.sequence')} ${index + 1}`}</label>
                            <Card size="small" key={index} style={{ border: "1px solid #000" }}>
                                <Row>
                                    <Col span={16}>
                                        <label style={{ color: "#667085" }}>{`${t('leave_type.label.approver')}`}</label>
                                    </Col>
                                    <Col span={8}>
                                        <span style={{ color: "#667085", display: "flex", justifyContent: "flex-end" }}>{t("leave_type.label.approvalDate")}</span>
                                    </Col>
                                    <Col span={16}>
                                        <span>{workflow?.listEmployees?.slice(0, 3).join(" , ")}</span>
                                        <> </>
                                        {workflow?.listEmployees?.length > 3 ? (
                                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                            <a
                                                onClick={() => {
                                                    setOpenListEmployee(true);
                                                    setListEmployees(workflow?.listEmployees);
                                                }}
                                                style={{
                                                    display: "inline-block",
                                                    borderRadius: "36px",
                                                    padding: "4px 12px",
                                                    fontSize: "0.7vw",
                                                    color: "#fff",
                                                    background: "var(--primary-color)",
                                                    textDecoration: "none",
                                                    fontWeight: "bold",
                                                    border: "1px solid var(--primary-color)",
                                                    cursor: "pointer"
                                                }}

                                            >
                                                {`+ ${workflow?.listEmployees?.length - 3} ...`}
                                            </a>
                                        ) : ""}
                                    </Col>
                                    <Col span={8}>
                                        <span style={{ display: "flex", justifyContent: "flex-end" }}>{workflow?.approveDate ? formatDateTime(workflow?.approveDate) : "-"}</span>
                                    </Col>
                                </Row>
                                <Row >
                                    <Col span={16} style={{ marginTop: '10px' }}>
                                        <label>
                                            {workflow?.workFlowtype}
                                        </label></Col>
                                    <Col span={8} style={{ marginTop: '10px' }} >
                                        <label style={{ display: "flex", justifyContent: "flex-end" }}> <StatusTag value={(workflow?.["approveStatus" + language])} /> </label>
                                    </Col>
                                </Row>
                            </Card >
                        </>
                    ))
                }
            </>

            {openListEmployee && (
                <Modal title={t("leave_type.label.approver")}
                    open={openListEmployee}
                    onCancel={() => setOpenListEmployee(false)}
                    footer={false}
                    width="510px"
                    maskClosable={false}
                >
                    <Card size="small" style={{ border: "1px solid #000" }}>
                        {listEmployees?.map((employee, index) => (
                            <label key={index}>
                                {employee}
                                <br />
                            </label>
                        ))}
                    </Card>
                </Modal>
            )}

            <Row justify={"end"}>
                <Button
                    type="default"
                    style={{ height: "40px", borderRadius: "8px" }}
                    onClick={() => { setIsExpenseModalOpen(false) }}
                >
                    {t("common.cancel").toUpperCase()}
                </Button>
            </Row>
        </Space>

    )
}

export default ExpenseWorkflow;